module.exports = __webpack_public_path__ + "img/swiper_no_img.614baf07.png";